import AlertToastsHook from './AlertToastsHook';

/**
 * Manage All Alert Toast Notifications
 **/
const AlertToastNotifications = () => <AlertToastsHook />;

export default AlertToastNotifications;
